//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './GDTMappingClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';



export type GetSingleGDTMappingQueryParameters = {
  id: number ;
}

export type PatchGDTMappingQueryParameters = {
  id: number ;
}

export type RemoveGDTMappingQueryParameters = {
  id: number ;
}

export function getFieldsUrl(): string {
  let url_ = getBaseUrl() + "/api/gdt/mappings/fields";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getFieldsDefaultOptions: Omit<UseQueryOptions<Types.MappingFieldDto[], unknown, Types.MappingFieldDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.MappingFieldDto[], unknown, Types.MappingFieldDto[]>, 'queryFn'>> = {
};
export function getGetFieldsDefaultOptions() {
  return getFieldsDefaultOptions;
};
export function setGetFieldsDefaultOptions(options: typeof getFieldsDefaultOptions) {
  getFieldsDefaultOptions = options;
}

export function getFieldsQueryKey(): QueryKey;
export function getFieldsQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'GDTMappingClient',
      'getFields',
    ]);
}
export function __getFields(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getFields(
axiosConfig    );
}

export function useGetFieldsQuery<TSelectData = Types.MappingFieldDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.MappingFieldDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetFieldsQuery<TSelectData = Types.MappingFieldDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.MappingFieldDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.MappingFieldDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getFields(context, axiosConfig) : __getFields,
    queryKey: getFieldsQueryKey(),
    ...getFieldsDefaultOptions as unknown as Omit<UseQueryOptions<Types.MappingFieldDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetFieldsData(queryClient: QueryClient, updater: (data: Types.MappingFieldDto[] | undefined) => Types.MappingFieldDto[], ) {
  queryClient.setQueryData(getFieldsQueryKey(),
    updater
  );
}

export function setGetFieldsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.MappingFieldDto[] | undefined) => Types.MappingFieldDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getAllUrl(): string {
  let url_ = getBaseUrl() + "/api/gdt/mappings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAllDefaultOptions: Omit<UseQueryOptions<Types.GDTMappingListDto[], unknown, Types.GDTMappingListDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GDTMappingListDto[], unknown, Types.GDTMappingListDto[]>, 'queryFn'>> = {
};
export function getGetAllDefaultOptions() {
  return getAllDefaultOptions;
};
export function setGetAllDefaultOptions(options: typeof getAllDefaultOptions) {
  getAllDefaultOptions = options;
}

export function getAllQueryKey(): QueryKey;
export function getAllQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'GDTMappingClient',
      'getAll',
    ]);
}
export function __getAll(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getAll(
axiosConfig    );
}

/**
 * Gets all GDT mappings.
 */
export function useGetAllQuery<TSelectData = Types.GDTMappingListDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.GDTMappingListDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAllQuery<TSelectData = Types.GDTMappingListDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GDTMappingListDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GDTMappingListDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getAll(context, axiosConfig) : __getAll,
    queryKey: getAllQueryKey(),
    ...getAllDefaultOptions as unknown as Omit<UseQueryOptions<Types.GDTMappingListDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets all GDT mappings.
 */
export function setGetAllData(queryClient: QueryClient, updater: (data: Types.GDTMappingListDto[] | undefined) => Types.GDTMappingListDto[], ) {
  queryClient.setQueryData(getAllQueryKey(),
    updater
  );
}

/**
 * Gets all GDT mappings.
 */
export function setGetAllDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GDTMappingListDto[] | undefined) => Types.GDTMappingListDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/gdt/mappings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'GDTMappingClient',
      'create',
    ]);
}

/**
 * Creates a GDT mapping.
 * @param dto Request parameter
 */
export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.GDTMappingDto, unknown, Types.CreateGDTMappingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.GDTMappingDto, unknown, Types.CreateGDTMappingDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateGDTMappingDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function getSingleUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/gdt/mappings/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSingleDefaultOptions: Omit<UseQueryOptions<Types.GDTMappingDto, unknown, Types.GDTMappingDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GDTMappingDto, unknown, Types.GDTMappingDto>, 'queryFn'>> = {
};
export function getGetSingleDefaultOptions() {
  return getSingleDefaultOptions;
};
export function setGetSingleDefaultOptions(options: typeof getSingleDefaultOptions) {
  getSingleDefaultOptions = options;
}

export function getSingleQueryKey(id: number): QueryKey;
export function getSingleQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetSingleGDTMappingQueryParameters;

    return trimArrayEnd([
        'GDTMappingClient',
        'getSingle',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'GDTMappingClient',
        'getSingle',
        ...params
      ]);
  }
}
export function __getSingle(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getSingle(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetSingleQuery<TSelectData = Types.GDTMappingDto, TError = unknown>(dto: GetSingleGDTMappingQueryParameters, options?: Omit<UseQueryOptions<Types.GDTMappingDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets GDT mapping by id.
 */
export function useGetSingleQuery<TSelectData = Types.GDTMappingDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.GDTMappingDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSingleQuery<TSelectData = Types.GDTMappingDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GDTMappingDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetSingleGDTMappingQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GDTMappingDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getSingle(context, axiosConfig) : __getSingle,
    queryKey: getSingleQueryKey(id),
    ...getSingleDefaultOptions as unknown as Omit<UseQueryOptions<Types.GDTMappingDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets GDT mapping by id.
 */
export function setGetSingleData(queryClient: QueryClient, updater: (data: Types.GDTMappingDto | undefined) => Types.GDTMappingDto, id: number) {
  queryClient.setQueryData(getSingleQueryKey(id),
    updater
  );
}

/**
 * Gets GDT mapping by id.
 */
export function setGetSingleDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GDTMappingDto | undefined) => Types.GDTMappingDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/gdt/mappings/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'GDTMappingClient',
      'patch',
      id as any,
    ]);
}

/**
 * Edits a GDT mapping.
 * @param id The GDT mapping id.
 * @param dto Request parameter
 */
export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.PatchGDTMappingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.PatchGDTMappingDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchGDTMappingDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchGDTMappingQueryParameters & {
  dto: Types.PatchGDTMappingDto;
}

/**
 * Edits a GDT mapping.
 * @param id The GDT mapping id.
 * @param dto Request parameter
 */
export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchGDTMappingQueryParameters}): UseMutationResult<void, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/gdt/mappings/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'GDTMappingClient',
      'remove',
      id as any,
    ]);
}

/**
 * Removes a GDT mapping.
 * @param id The GDT mapping id.
 */
export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveGDTMappingQueryParameters

/**
 * Removes a GDT mapping.
 * @param id The GDT mapping id.
 */
export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveGDTMappingQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}